module.exports = __webpack_public_path__ + "img/toggle-panel.ca940535.svg";